import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import Card from '../../../ui/Card/Card';
import styles from './TruncatedTextCell.module.css';
import cn from 'classnames';

type TruncatedTextCellProps = {
    children: string;
    className?: string;
};

const TruncatedTextCell = ({ children, className }: TruncatedTextCellProps) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [anchorRef, setAnchorRef] = useState<HTMLSpanElement | null>(null);
    const [tooltipRef, setTooltipRef] = useState<HTMLDivElement | null>(null);
    const { attributes, styles: popperStyles } = usePopper(anchorRef, tooltipRef, {
        placement: 'top',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 5],
                },
            },
        ],
    });

    const onMouseEnter = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        const { offsetWidth, scrollWidth } = e.currentTarget;
        setShowTooltip(offsetWidth < scrollWidth);
    };

    return (
        <>
            <span
                ref={setAnchorRef}
                className={cn(styles.text, className)}
                onMouseEnter={onMouseEnter}
                onMouseLeave={() => setShowTooltip(false)}
            >
                {children}
            </span>
            {showTooltip && (
                <div ref={setTooltipRef} style={{ ...popperStyles.popper, pointerEvents: 'none' }} {...attributes}>
                    <Card className={styles.content}>{children}</Card>
                </div>
            )}
        </>
    );
};

export default TruncatedTextCell;
